enum ColorsPaletteEvents {
  /**
   * Dispatched when a color button is pressed on a color palette.
   *
   * Callback signature:
   *
   * `colorData`: `IColorData`. Contains the color data of color button that was pressed
   *
   * `colorPalette`: `ColorsPalette`. The color palette that dispatched the event.
   */
  COLOR_SELECTED = 'colorSelected',

  /**
   * Dispatched when the pointer (mouse, tap) is over a color button of a color palette.
   *
   * Callback signature:
   *
   * `colorData`: `IColorData`. Contains the color data of color button that was pressed
   *
   * `colorPalette`: `ColorsPalette`. The color palette that dispatched the event.
   */
  COLOR_POINTER_OVER = 'colorPointerOver',
}

export default ColorsPaletteEvents;
